document.addEventListener('DOMContentLoaded', () => {
  const updateCartUI = () => {
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(response => response.json())
      .then(sections => {
        if (sections['cart-drawer']) {
          const drawer = document.getElementById('CartDrawer');
          if (drawer) {
            drawer.innerHTML = new DOMParser()
              .parseFromString(sections['cart-drawer'], 'text/html')
              .getElementById('CartDrawer').innerHTML;
          }
        }

        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          bubble.innerHTML = new DOMParser()
            .parseFromString(sections['cart-icon-bubble'], 'text/html')
            .getElementById('cart-icon-bubble').innerHTML;
        }
      })
      .catch(e => console.error('Error al actualizar el carrito:', e));
  };

  // NUEVO: manejar clics sobre el componente cart-remove-button
  document.body.addEventListener('click', (e) => {
    const isRemove = e.target.closest('cart-remove-button');

    if (isRemove) {
      // 🔁 Forzar recarga de la página
      setTimeout(() => {
        location.reload();
      }, 600);
      return;
    }

    const button = e.target.closest('button');
    const nameAttr = button?.getAttribute('name') || '';
    if (nameAttr === 'plus' || nameAttr === 'minus') {
      setTimeout(updateCartUI, 800);
    }
  });
});





